import { IApplicationState } from '../../types/redux';
import { EEstimationTargets } from '@cian/valuation-main-filters-widget';

export const selectIsDataPaymentFeatureActive = (state: IApplicationState) =>
  state.filters.estimationTarget === EEstimationTargets.flat && state.featureToggles.isDataPaymentFeatureActive;
